import { useRef, useState } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';

export const useCuration = ({
  curationId,
  storeId,
  preview
}) => {
  const carouselProductsRef = useRef([]);
  const [startIndex, setStartIndex] = useState(0);
  const pageSize = 24;
  const {
    data
  } = useDataModel('curation', {
    variables: {
      curationId: [curationId],
      storeId,
      pageSize,
      startIndex,
      preview
    },
    skip: !curationId
  });
  const { curation } = data || {};
  const { metadata, products = [] } = curation ? curation[0] || {} : {};
  // carouselProductsRef is used for pagination
  carouselProductsRef.current.splice(startIndex, pageSize, ...products);

  const { productCount } = metadata || {};
  const { allProducts } = productCount || {};
  const carouselProducts = carouselProductsRef.current;

  const totalItems = Number(allProducts) || 0;
  const getMoreCurationItems = (itemsPerShift) => {
    const hasMorePages = itemsPerShift?.realIndex < totalItems;
    // eslint-disable-next-line max-len
    const canPaginate = (itemsPerShift?.realIndex + itemsPerShift?.visibleSlides?.length - 1) >= carouselProducts.length;
    const hasMoreSkus = carouselProducts.length < totalItems;
    if (hasMorePages && (canPaginate && hasMoreSkus)) {
      setStartIndex(carouselProducts.length + 1);
    }
  };

  return [
    metadata,
    carouselProducts,
    getMoreCurationItems
  ];

};
